/**
 * Email utility functions for authentication
 */

/**
 * Normalize email address for authentication
 * Trims whitespace and converts to lowercase to handle Cognito's case-sensitive usernames
 *
 * @param email - Raw email input from user
 * @returns Normalized email (trimmed + lowercased)
 *
 * @example
 * normalizeEmail('User@Example.Com') // returns 'user@example.com'
 * normalizeEmail('  user@example.com  ') // returns 'user@example.com'
 */
export function normalizeEmail(email: string) {
  if (!email || typeof email !== 'string') {
    return '';
  }
  return email.trim().toLowerCase();
}

/**
 * Validate email format (basic check)
 *
 * @param email - Email address to validate
 * @returns true if email format is valid
 *
 * @example
 * isValidEmail('user@example.com') // returns true
 * isValidEmail('not-an-email') // returns false
 */
export function isValidEmail(email: string) {
  if (!email || typeof email !== 'string') {
    return false;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
